import { render, staticRenderFns } from "./InspirationListing.vue?vue&type=template&id=70dc391a&"
import script from "./InspirationListing.vue?vue&type=script&lang=ts&"
export * from "./InspirationListing.vue?vue&type=script&lang=ts&"
import style0 from "./InspirationListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports